
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/owners/literature",
      function () {
        return require("private-next-pages/owners/literature.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/owners/literature"])
      });
    }
  